export default __webpack_public_path__ + "locales/lo-LA/DeleteProfileEverDialog.json?hash=96a6733adb22c7316c034eb01a759a5c";